import Calendar from 'react-calendar';

import { useState, useEffect } from 'react';
import { parseImgsToFullDate, parseImgsToTime, parseImgToDate } from './ImageFunctions';


export const Files = ({ date, files, sendDataToParent }) => {
    
    let fileLinks = [];
    let i = 2 ;

    function handleSubmit(e) {
        sendDataToParent(e.target.value);
    }

    files.forEach(file => {
        
        let fileNameDates = parseImgsToFullDate(file);
        if( fileNameDates.toLocaleDateString() === date.toLocaleDateString()) {
            
            let fileToPush = <option value={i} key={i}>{parseImgsToTime(file)}</option>;
            fileLinks.push(fileToPush);
        }
        i++;
    });


    return (
        <>
            <p className='whiteText'>Date: {date.toLocaleDateString()}</p>
            <label className='whiteText' htmlFor="times" >Time:</label>
            <select id="times" name="times" onChange={e => handleSubmit(e)}>
                <option value="">Choose a Time</option>
                { fileLinks.length ? fileLinks : <option>No Images Available</option> }
            </select>
        </>
    );
}



export const Cal = ({ sendDataToParent, imgDates }) => {
    let [calDate, setCalDate] = useState(new Date());

    function handleDateChange() {
        sendDataToParent(calDate);
    }
    
    useEffect(() => {
        handleDateChange();
    }, [calDate]);


    return (
        <>
            <Calendar 
                onChange={(val) => setCalDate(val)}
                tileDisabled={( { date, view } ) => {
                        if(view === 'month') {
                            return !imgDates.some(imgDate => 
                                date.getFullYear() === new Date(imgDate).getFullYear() &&
                                date.getMonth() === new Date(imgDate).getMonth() &&
                                date.getDate() === new Date(imgDate).getDate()
                            );
                        }
                    }
                }
            />
        </>
    );
    
}
